export const environment = {
	webBase: 'https://patientnavigator.vivascore.ai',
	appEnvironmentBaseUrl: 'https://api.alulahealth.com/health/environment',
	deeplinkURL: 'patientnavigator://',

	dislaimerUrl: 'https://vivascore.ai/disclaimer/',
	privacyPolicy: 'https://patientadvocate.co.uk/legal/privacy-notice',
	termsOfUse: 'https://patientadvocate.co.uk/legal/terms-of-use',
	faqUrl: 'https://vivascore.ai/faq/',
	useHelpCenter: false,
	aboutUsUrl: 'https://patientadvocate.co.uk/about/what-we-do',
	contactUsUrl: 'https://patientadvocate.co.uk/contact',
	welcomeBackground: '',

	oneSignalAppId: 'd8002cf3-00f4-472c-9a5f-41a7c8be5b6e',
	environmentName: 'patientnavigator',
	production: true,
	apiProduction: true,
	showUatBuildBanner: false,
	faceScanPasswordEmailMessageOverride: '',

	countryCode: 'gb',
	defaultMobileCountryCode: 'gb',
	organizationId: '0ac6cb3e-5dcf-4ca3-a7e2-08dea7aafa9f',
	scanFriendAllowed: false,

	/** Unauthenticated PN services API base (appends /{personId}). */
	pnExternalServicesBaseUrl: 'https://dev.patientnavigator.co.uk/external_vivascore/services',

	enableMobileRegistation: true,
	enableWebRegistation: true,

	enableLocalAccounts: true,
	enableExternalLogin: false,

	enableEnterpriseRegistration: false,

	iosAuthRedirect: 'not-defined',
	androidAuthRedirect: 'not-defined',
	allowTelematics: false,

	whatsappEnabled: false,

	androidStoreLink: 'https://play.google.com/store/apps/details?id=ai.vivascore.patientnavigator',
	iosStoreLink: 'https://apps.apple.com/app/id6793070588',

	E2E_TEST_MODE: false,

	allowedDebugEmails_internal: [] as string[],
	allowedDebugEmails_external: [] as string[],

	defaultCulture: 'en-GB',
	availablelanguages: [
		{ culture: 'en-GB', text: 'English (United Kingdom)', dir: 'ltr' },
	],

};
